import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSwitch from "framework/components/DPSwitch"
import DPDropDown from "framework/components/DPDropDown"
import { Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import ReactPaginate from "react-paginate"
import { GetVarientImages, getCommonName } from "./ProductController"


const ProductVarientContent = ({
  autoCode,
  strProductCode,
  dbCost,
  dbAVGCost,
  strProductDesc,
  setAlertColor,
  setAlertMsg,
  setAlertShow,
  mergerItems,
  setMergerItems,
  varient1apply,
  allColors,
  allSizes,
  dbSelling,
  Disabled,
  variant1name,
  variant2name,
  setVariantPNG,
  variantPNG,
  PNGPath,
  linkName,
  setAllColors,
  setAllSizes,
  getAllColors,
  getAllSizes
}) => {


  const [displayvariants, setDisplayVariants] = useState([])
  const [pngNames, setPngNames] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage, setPostsPerPage] = useState(10)
  const [postsPerPageColor, setPostsPerPageColor] = useState(5)
  const [currentPageColor, setCurrentPageColor] = useState(1)
  const [postsPerPageSize, setPostsPerPageSize] = useState(5)
  const [currentPageSize, setCurrentPageSize] = useState(1)
  const [colorSearch, setColorSearch] = useState('')
  const [colorSearchMode, setColorSearchMode] = useState('code')
  const [sizeSearch, setSizeSearch] = useState('')
  const [sizeSearchMode, setSizeSearchMode] = useState('code')

  useEffect(async () => {
    const filteredVarientItems = [...(mergerItems || []).reduce((map, obj) => map.set(obj.variant1, obj), new Map()).values()]

    const variant1Set = new Set(filteredVarientItems.map(element => element.variant1));

    const modifiedVariant1 = allColors.map(color => {
      if (variant1Set.has(color.code)) {
        color.apply = true;
      }
      return color;
    });

    setAllColors(modifiedVariant1)

    const filteredVarientItems2 = [...(mergerItems || []).reduce((map, obj) => map.set(obj.variant2, obj), new Map()).values()]
    const variant2Set = new Set(filteredVarientItems2.map(element => element.variant2));

    const modifiedVariant2 = allSizes.map(size => {
      if (variant2Set.has(size.code)) {
        size.apply = true;
      }
      return size;
    });

    setAllSizes(modifiedVariant2)

    setDisplayVariants(filteredVarientItems)
  }, [mergerItems])


  useEffect(async () => {
    const varientImages = await GetVarientImages()
    setPngNames(varientImages)
  }, [])


  function Generate() {

    if (strProductDesc == '') {
      setAlertColor('danger')
      setAlertMsg('Please Select Product Or Enter product description')
      setAlertShow(true)
      setTimeout(() => {
        setAlertShow(false)
      }, 5000);
      return
    }

    let colordata = []
    let sizedata = []
    let combination = []


    colordata = allColors.filter(x => x.apply == true)
    sizedata = allSizes.filter(x => x.apply == true)

    var productcode = strProductCode != '' ? strProductCode : autoCode

    if (colordata.length > 0 && sizedata.length > 0) {

      var id = 1

      colordata.map(color => {
        sizedata.map(size => {

          combination.push({
            id: id++,
            proCode: productcode,
            name: strProductDesc + ' ' + color.name + ' ' + size.name,
            code: productcode + color.code + size.code,
            variant1: color.code,
            variant2: size.code,
            cost: parseFloat(dbCost).toFixed(2),
            avgCost: parseFloat(dbAVGCost).toFixed(2),
            linkCost: parseFloat(0).toFixed(2),
            reOrderlvl: 0,
            reOrderQty: 0,
            maxlvl: 0,
            opBal: 0,
            sih: 0,
            color: color.reference,
            selling: parseFloat(dbSelling).toFixed(2),
          })

        })
      })

    } else {
      if (colordata.length == 0) {
        setAlertColor('danger')
        setAlertMsg('Please Select a Color')
        setAlertShow(true)
        setMergerItems([{
          id: 1,
          proCode: "",
          code: "",
          name: "",
          variant1: "",
          variant2: "",
          cost: parseFloat(0).toFixed(2),
          avgCost: parseFloat(0).toFixed(2),
          reOrderlvl: "",
          reOrderQty: "",
          maxlvl: "",
          opBal: "",
          sih: 0,
          color: "",
          selling: parseFloat(0).toFixed(2),
          linkCost: parseFloat(0).toFixed(2),
        }])
        setTimeout(() => {
          setAlertShow(false)
        }, 5000);
        return
      } else {
        if (sizedata.length == 0) {
          setAlertColor('danger')
          setAlertMsg('Please Select a Size')
          setAlertShow(true)
          setMergerItems([{
            id: 1,
            proCode: "",
            code: "",
            name: "",
            variant1: "",
            variant2: "",
            cost: parseFloat(0).toFixed(2),
            avgCost: parseFloat(0).toFixed(2),
            reOrderlvl: "",
            reOrderQty: "",
            maxlvl: "",
            opBal: "",
            sih: 0,
            color: "",
            selling: parseFloat(0).toFixed(2),
            linkCost: parseFloat(0).toFixed(2),
          }])
          setTimeout(() => {
            setAlertShow(false)
          }, 5000);
          return
        }
      }
    }
    setMergerItems(combination)
    setCurrentPage(1)
  }

  // function RemoveRow(id) {

  //   const modifiedRows = [...mergerItems]
  //   const objectIndex = mergerItems.findIndex(obj => obj.id === id);
  //   modifiedRows.splice(objectIndex, 1)
  //   setMergerItems(modifiedRows)

  // }

  function RemoveRow(id) {

    const modifiedRows = [...mergerItems]
    const objectIndex = mergerItems.findIndex(obj => obj.id === id);
    modifiedRows.splice(objectIndex, 1);


    if (modifiedRows.length === 0) {
      modifiedRows.push({
        id: 1,
        proCode: "",
        code: "",
        name: "",
        variant1: "",
        variant2: "",
        cost: parseFloat(0).toFixed(2),
        avgCost: parseFloat(0).toFixed(2),
        reOrderlvl: "",
        reOrderQty: "",
        maxlvl: "",
        opBal: "",
        sih: 0,
        color: "",
        selling: parseFloat(0).toFixed(2),
        linkCost: parseFloat(0).toFixed(2),
      });
    }

    // Reassign unique IDs to the remaining rows

    for (let i = 0; i < modifiedRows.length; i++) {
      modifiedRows[i].id = i + 1;
    }

    setMergerItems(modifiedRows)

  }


  /**
      * @description This function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = mergerItems.findIndex(obj => obj.id === id);
    const newObject = { ...mergerItems[objectIndex], [element]: value };
    setMergerItems(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  const changeVariant2RowValueChanges = (value, id, element) => {
    const objectIndex = allSizes.findIndex(obj => obj.id === id);
    const newObject = { ...allSizes[objectIndex], [element]: value };
    setAllSizes(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  const changeVariant1RowValueChanges = (value, id, element) => {
    const objectIndex = allColors.findIndex(obj => obj.id === id);
    const newObject = { ...allColors[objectIndex], [element]: value };
    setAllColors(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  function EnableAllVariant1(e) {
    const updatedVariant1 = allColors.map((item, index) => {
      item.apply = e
      return item;
    })
    setAllColors(updatedVariant1)

  }

  function EnableAllVariant2(e) {
    const updatedVariant2 = allSizes.map((item, index) => {
      item.apply = e
      return item;
    })
    setAllSizes(updatedVariant2)
  }


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const handlePageClickColor = (event) => {
    setCurrentPageColor(event.selected + 1);
  };


  const handlePageClickSize = (event) => {
    setCurrentPageSize(event.selected + 1);
  };


  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = mergerItems.slice(indexOfFirstPost, indexOfLastPost)


  //color search 

  const fillteredColors = allColors.filter((item) => {
    if (colorSearchMode == null)
      return item
    else if (item[colorSearchMode].toLowerCase().includes(colorSearch.toLowerCase())) {
      return item
    }
  })


  const fillteredSizes = allSizes.filter((item) => {
    if (sizeSearchMode == null)
      return item
    else if (item[sizeSearchMode].toLowerCase().includes(sizeSearch.toLowerCase())) {
      return item
    }
  })


  const indexOfLastPostColor = currentPageColor * postsPerPageColor
  const indexOfFirstPostColor = indexOfLastPostColor - postsPerPageColor
  const currentPostsColor = fillteredColors.slice(indexOfFirstPostColor, indexOfLastPostColor)


  const indexOfLastPostSize = currentPageSize * postsPerPageSize
  const indexOfFirstPostSize = indexOfLastPostSize - postsPerPageSize
  const currentPostsSize = fillteredSizes.slice(indexOfFirstPostSize, indexOfLastPostSize)

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={4} className="mb-12-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Select PNG"
            optionGroup={pngNames}
            selectedGroup={variantPNG}
            onChange={setVariantPNG}
            disabled={Disabled}
          />
        </Col>
        <Col sm={12} md={4} className="mb-12-sm">
          <Button size="sm" color="primary" onClick={() => {
            getAllColors()
            getAllSizes()
          }} disabled={Disabled}>
            Refresh Color Size
          </Button>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-12-sm">
          <label className="col-sm-12 col-md-4 col-form-label">
            {variant1name == '' ? 'Color' : variant1name}
          </label>
          <div className="input-group mb-0">
            <DPTextBoxforgrid
              name="search"
              id="search"
              value={colorSearch}
              placeholder={"Color Search by " + colorSearchMode}
              onChange={(e) => {
                setColorSearch(e.target.value)
              }}
            />
          </div>
          <div >
            <table style={{ fontSize: "11px" }} id={"tableVariant1"}>
              <thead className="table-light">
                <tr>
                  <th style={{ cursor: 'pointer', minWidth: '150px' }} onClick={() => {
                    setColorSearchMode('code')
                  }}>Code </th>
                  <th style={{ cursor: 'pointer', minWidth: '300px' }} onClick={() => {
                    setColorSearchMode('name')
                  }}>{variant1name == '' ? 'Color' : variant1name} </th>
                  <th style={{ display: 'grid', minWidth: '50px' }}>
                    <label>Apply</label>
                    <DPSwitch
                      checked={allColors.every(x => x.apply == true)}
                      disabled={Disabled}
                      onChange={(e) => {
                        EnableAllVariant1(e)
                      }}
                    />
                  </th>
                </tr>
              </thead>
              <tbody disabled={true}>
                {(currentPostsColor || []).map((color, index) => (
                  <ColorRow color={color} index={index} varient1={varient1apply} Disabled={Disabled} changeVariant2RowValueChanges={changeVariant1RowValueChanges} />
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <Row className="mt-2">
              <Col md="12">
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={Math.ceil(fillteredColors.length / postsPerPageColor)}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClickColor}
                  forcePage={currentPageColor - 1}
                  renderOnZeroPageCount={null}
                  activeClassName={'active'}
                  activeLinkClassName={'page-link'}
                  containerClassName={'pagination justify-content-start pagination-sm'}
                />
              </Col>
            </Row>
          </div>
        </Col>
        <Col sm={12} md={6} className="mb-12-sm">
          <Row>
            <label className="col-sm-12 col-md-4 col-form-label">
              {variant2name == '' ? 'Size' : variant2name}
            </label>
            <div className="input-group mb-0">
              <DPTextBoxforgrid
                name="search"
                id="search"
                value={sizeSearch}
                placeholder={"Size Search by " + sizeSearchMode}
                onChange={(e) => {
                  setSizeSearch(e.target.value)
                }}
              />
            </div>
            <div>
              <table style={{ fontSize: "11px" }} id={"tableVariant2"}>
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: 'pointer', minWidth: '150px' }} onClick={() => {
                      setSizeSearchMode('code')
                    }}>Code </th>
                    <th style={{ cursor: 'pointer', minWidth: '300px' }} onClick={() => {
                      setSizeSearchMode('name')
                    }}>{variant2name == '' ? 'Size' : variant2name} </th>
                    <th style={{ display: 'grid', minWidth: '50px' }}>
                      <label>Apply</label>
                      <DPSwitch
                        checked={allSizes.every(x => x.apply == true)}
                        disabled={Disabled}
                        onChange={(e) => {
                          EnableAllVariant2(e)
                        }}
                      /></th>
                  </tr>
                </thead>
                <tbody disabled={true}>
                  {(currentPostsSize || []).map((size, index) => (
                    <SizeRow size={size} index={index} Disabled={Disabled} changeVariant1RowValueChanges={changeVariant2RowValueChanges} />
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              <Row className="mt-2">
                <Col md="12">
                  <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(fillteredSizes.length / postsPerPageSize)}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClickSize}
                    forcePage={currentPageSize - 1}
                    renderOnZeroPageCount={null}
                    activeClassName={'active'}
                    activeLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-start pagination-sm'}
                  />
                </Col>
              </Row>
            </div>
          </Row>
        </Col>
        {/* <Col sm={12} md={1} className="mb-12" style={{ display: 'grid', gridAutoFlow: 'column', alignItems: 'center', justifyContent: 'center' }}>
        </Col> */}
      </Row>
      <Row style={{ display: 'flex', alignItems: 'center', alignContent: 'center', flexDirection: 'column', marginTop: '20px' }}>
        <Button
          style={{ width: "50%", marginBottom: "10px" }}
          color="primary"
          className="btn-block"
          disabled={Disabled}
          onClick={() => Generate()}
        >
          GENERATE
        </Button>
      </Row>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <Row className="mb-4">
            <label className="col-sm-12 col-md-4 col-form-label">
              Generated Products
            </label>
            <div style={{ overflowY: 'auto', paddingTop: '10px' }}>
              <table style={{ fontSize: "11px" }} id={"tableCombination"}>
                <thead className="table-light">
                  <tr>
                    <th></th>
                    <th>Pro Code </th>
                    <th>Code </th>
                    <th>Decription</th>
                    <th>{variant1name == '' ? 'Color' : variant1name}</th>
                    <th>{variant2name == '' ? 'Size' : variant2name}</th>
                    <th>Cost</th>
                    <th>AVG Cost </th>
                    <th>Selling </th>
                    <th>{linkName}</th>
                    <th>Re Order Lvl </th>
                    <th>Re Order Qty</th>
                    <th>Max lvl </th>
                    <th>OP balance </th>
                    <th>SIH</th>
                    <th>Color</th>
                  </tr>
                </thead>
                <tbody disabled={true}>
                  {(currentPosts).map((data, index) => (
                    <MergeRow FormRow={data} index={index} Disabled={Disabled} RemoveRow={RemoveRow} changeRowValueChanges={changeRowValueChanges} indexOfFirstPost={indexOfFirstPost} />
                  ))}

                </tbody>
              </table>
            </div>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(mergerItems.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <label className="col-sm-12 col-md-4 col-form-label">
          Product Display
        </label>
      </Row>
      <div style={{ height: '400' }}>
        {(displayvariants || []).map((row, key) => (
          <Row>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
              {(currentPosts).map((data, index) => {
                if (row.variant1 == data.variant1) {

                  var header = allSizes.filter(x => x.code == data.variant2)
                  if (header.length != 0) {
                    return (
                      <div style={{ display: 'flex', width: '180px', justifyContent: 'center', margin: '5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                          <label style={{ position: 'relative', fontWeight: 700, color: 'white', marginTop: '20px', top: '35%', textShadow: '-2px -2px 0 black,-2px -1px 0 black,-2px 0px 0 black,-2px 1px 0 black,-2px 2px 0 black,-1px -2px 0 black,-1px -1px 0 black,-1px 0px 0 black,-1px 1px 0 black,-1px 2px 0 black,0px -2px 0 black,0px -1px 0 black,0px 0px 0 black,0px 1px 0 black,0px 2px 0 black,1px -2px 0 black,1px -1px 0 black,1px 0px 0 black,1px 1px 0 black,1px 2px 0 black,2px -2px 0 black,2px -1px 0 black,2px 0px 0 black,2px 1px 0 black,2px 2px 0 black' }}>
                            {header[0].display == null ? '' : header[0].display}</label>
                          <img src={PNGPath}
                            width={'100px'} height={'100px'} style={{ background: data.color, backgroundBlendMode: 'darken' }}></img>
                          <label>{data.name}</label>
                        </div>
                      </div>
                    )
                  }
                }
              })}
            </div>
          </Row>
        ))}
      </div>
    </React.Fragment>
  )
}
export default ProductVarientContent



const ColorRow = ({ color, index, Disabled, changeVariant2RowValueChanges }) => {

  return (
    <tr key={index}>
      <td style={{ width: '150px' }}>
        <DPTextBoxforgrid
          name="Code"
          id={'colorcode' + index}
          value={color.code}
          disabled={true}
          onChange={(e) => {
            changeVariant2RowValueChanges(e.target.value, color.id, 'code')
          }}
        />
      </td>
      <td style={{ paddingRight: '5px', width: '300px' }}>
        <DPTextBoxforgrid
          name="color"
          id={'color' + index}
          value={color.name}
          disabled={true}
          onChange={(e) => {
            changeVariant2RowValueChanges(e.target.value, color.id, 'name')
          }}
        />
      </td>
      <td>
        <DPSwitch
          id={'applycolor' + index}
          rowClass={"mb-4-sm-ml-4"}
          height={23}
          handleDiameter={15}
          checked={color.apply}
          onChange={(e) => {
            changeVariant2RowValueChanges(e, color.id, 'apply')
          }}
          disabled={Disabled}
        />
      </td>
      <td style={{ display: 'none' }}>
        <DPTextBoxforgrid
          name="color"
          id={'colorref' + index}
          value={color.reference}
          disabled={true}
          onChange={(e) => {
            changeVariant2RowValueChanges(e.target.value, color.id, 'reference')
          }}
        />
      </td>
    </tr>
  )

}

const SizeRow = ({ size, index, Disabled, varinat2Value, changeVariant1RowValueChanges }) => {

  return (
    <tr key={index}>
      <td style={{ width: '150px' }}>
        <DPTextBoxforgrid
          name="Code"
          id={'sizeCode' + index}
          value={size.code}
          disabled={true}
          onChange={(e) => {
            changeVariant1RowValueChanges(e.target.value, size.id, 'code')
          }}
        />
      </td>
      <td style={{ paddingRight: '5px', width: '300px' }}>
        <DPTextBoxforgrid
          name="color"
          id={'sizeName' + index}
          value={size.name}
          disabled={true}
          onChange={(e) => {
            changeVariant1RowValueChanges(e.target.value, size.id, 'name')
          }}
        />
      </td>
      <td>
        <DPSwitch
          rowClass={"mb-4-sm"}
          id={'applysize' + index}
          height={23}
          handleDiameter={15}
          checked={size.apply}
          disabled={Disabled}
          onChange={(e) => {
            changeVariant1RowValueChanges(e, size.id, 'apply')
          }}
        />
      </td>
    </tr>
  )
}

const MergeRow = ({ FormRow, index, RemoveRow, Disabled, changeRowValueChanges, indexOfFirstPost }) => {

  return (
    <tr>
      <td>{indexOfFirstPost + index + 1}</td>
      <td style={{ width: '120px' }}>
        <DPTextBoxforgrid
          name="procode"
          id={'procode' + index}
          value={FormRow.proCode}
          disabled={true}
          onChange={(e) => {
            changeRowValueChanges(e.target.value, FormRow.id, 'proCode')
          }}
        />
      </td>
      <td style={{ width: '150px' }}>
        <DPTextBoxforgrid
          name="code"
          id={'code' + index}
          value={FormRow.code}
          disabled={true}
          onChange={(e) => {
            changeRowValueChanges(e.target.value, FormRow.id, 'code')
          }}
        />
      </td>
      <td style={{ width: '350px' }}>
        <DPTextBoxforgrid
          name="desc"
          id={'desc' + index}
          value={FormRow.name}
          disabled={Disabled}
          onChange={(e) => {
            changeRowValueChanges(e.target.value, FormRow.id, 'name')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="variant1"
          id={'variant1' + index}
          value={FormRow.variant1}
          disabled={true}
          onChange={(e) => {
            changeRowValueChanges(e.target.value, FormRow.id, 'variant1')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="variant2"
          id={'variant2' + index}
          value={FormRow.variant2}
          disabled={true}
          onChange={(e) => {
            changeRowValueChanges(e.target.value, FormRow.id, 'variant2')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="cost"
          id={'cost' + index}
          value={FormRow.cost}
          textAlign="right"
          disabled={Disabled}
          onChange={e => {
            let CostPrice = Numeric(e.target, 8, 2, false)
            if (CostPrice == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'cost')
            }
            else {
              changeRowValueChanges(CostPrice, FormRow.id, 'cost')
            }

          }}
          onBlur={e => {
            let CostPrice = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(CostPrice, FormRow.id, 'cost')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="avgCost"
          id={'avgCost' + index}
          textAlign="right"
          value={FormRow.avgCost}
          disabled={Disabled}
          onChange={e => {
            let AVGCost = Numeric(e.target, 8, 2, false)
            if (AVGCost == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'avgCost')
            }
            else {
              changeRowValueChanges(AVGCost, FormRow.id, 'avgCost')
            }
          }}
          onBlur={e => {
            let AVGCost = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(AVGCost, FormRow.id, 'avgCost')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="sellingCost"
          id={'sellingCost' + index}
          textAlign="right"
          value={FormRow.selling}
          disabled={Disabled}
          onChange={e => {
            let AVGCost = Numeric(e.target, 8, 2, false)
            if (AVGCost == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'selling')
            }
            else {
              changeRowValueChanges(AVGCost, FormRow.id, 'selling')
            }
          }}
          onBlur={e => {
            let AVGCost = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(AVGCost, FormRow.id, 'selling')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="linkCost"
          id={'linkCost' + index}
          textAlign="right"
          value={FormRow.linkCost}
          disabled={Disabled}
          onChange={e => {
            let AVGCost = Numeric(e.target, 8, 2, false)
            if (AVGCost == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'linkCost')
            }
            else {
              changeRowValueChanges(AVGCost, FormRow.id, 'linkCost')
            }
          }
          }
          onBlur={e => {
            let AVGCost = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(AVGCost, FormRow.id, 'linkCost')
          }}
        />
      </td>

      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="reOrderLvl"
          id={'reOrderLvl' + index}
          textAlign="right"
          value={FormRow.reOrderlvl}
          disabled={Disabled}
          onChange={e => {
            let ReorderLevel = Numeric(e.target, 8, 2, false)
            if (ReorderLevel == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'reOrderlvl')
            }
            else {
              changeRowValueChanges(ReorderLevel, FormRow.id, 'reOrderlvl')
            }
          }}
          onBlur={e => {
            let ReorderLevel = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(ReorderLevel, FormRow.id, 'reOrderlvl')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="reOrderQty"
          id={'reOrderQty' + index}
          textAlign="right"
          value={FormRow.reOrderQty}
          disabled={Disabled}
          onChange={e => {
            let Reorder = Numeric(e.target, 8, 2, false)
            if (Reorder == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'reOrderQty')
            }
            else {
              changeRowValueChanges(Reorder, FormRow.id, 'reOrderQty')
            }
          }}
          onBlur={e => {
            let Reorder = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(Reorder, FormRow.id, 'reOrderQty')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="maxLvl"
          id={'maxLvl' + index}
          textAlign="right"
          value={FormRow.maxlvl}
          disabled={Disabled}
          onChange={e => {
            let Maxqty = Numeric(e.target, 8, 2, false)
            if (Maxqty == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'maxlvl')
            }
            else {
              changeRowValueChanges(Maxqty, FormRow.id, 'maxlvl')
            }

          }}
          onBlur={e => {
            let Maxqty = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(Maxqty, FormRow.id, 'maxlvl')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="opBalance"
          id={'opBalance' + index}
          textAlign="right"
          value={FormRow.opBal}
          disabled={Disabled}
          onChange={e => {
            let valOS = Numeric(e.target, 8, 2, false)
            if (valOS == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'opBal')
            }
            else {
              changeRowValueChanges(valOS, FormRow.id, 'opBal')
            }
          }}
          onBlur={e => {
            let valOS = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(valOS, FormRow.id, 'opBal')
          }}
        />
      </td>
      <td style={{ width: '70px' }}>
        <DPTextBoxforgrid
          name="sih"
          id={'sih' + index}
          textAlign="right"
          value={FormRow.sih}
          disabled={true}
          onChange={e => {
            let valOS = Numeric(e.target, 8, 2, false)
            if (valOS == "") {
              changeRowValueChanges(parseFloat(0).toFixed(2), FormRow.id, 'sih')
            }
            else {
              changeRowValueChanges(valOS, FormRow.id, 'sih')
            }
          }}
          onBlur={e => {
            let valOS = DecimalValidation(e.target.value, 0, true, 2)
            changeRowValueChanges(valOS, FormRow.id, 'sih')
          }}
        />
      </td>
      <td style={{ width: '30px' }}>
        <button
          style={{ backgroundColor: FormRow.color, width: '30px', height: '30px' }}
          disabled={true}
        >
        </button>
        <div style={{ display: 'none' }}>
          <DPTextBoxforgrid
            name="procode"
            id={"colobtn" + index}
            value={FormRow.color}
            disabled={true}
          />
        </div>
      </td>
      <td>
        <Button
          outline
          disabled={Disabled}
          color="danger"
          id={"btnDelete" + index}
          onClick={e => {
            RemoveRow(FormRow.id)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>

    </tr>
  )

}
